import { render, staticRenderFns } from "./StrandeBase.vue?vue&type=template&id=3fc1ee9e"
import script from "./StrandeBase.vue?vue&type=script&lang=js"
export * from "./StrandeBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports